import { render } from "./GalleryView.vue?vue&type=template&id=3981de99"
import script from "./GalleryView.vue?vue&type=script&lang=js"
export * from "./GalleryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__